import React, { useContext, useEffect } from "react";
import { Col, Button, Checkbox } from "antd";
import { Controller } from "react-hook-form";
import FormItem from "../form-item";
import ImageUploader from "../../form-components/image-uploader-client";
import FieldBuilder from "../../form-components/field-builder";
import Image from "../antd/image";
import { useTranslation } from "react-i18next";
import { MediumFor } from "../../../models/medium/enum";
import { IMedium } from "../../../models/medium/response";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import AppContext from "../../../context/app/context";

interface Props {
    fieldName: string;
    currentId?: any;
    fieldValue?: any;
    currentImage: any;
    newImageUrl: string | null;
    isChanged: boolean;
    onUpload: () => void;
    onUpdateBackground: () => void;
    onImageChange: (response: IMedium | null) => void;
    setWithoutBackgrounds: (value: boolean) => void;
    onDeleteImage: () => void;
    isImageLoading: boolean;
    notRequired?: boolean;
    title?: string;
    value: any
    force?:boolean
}

const ImageFieldBlock: React.FC<Props> = ({
    fieldName,
    currentImage,
    newImageUrl,
    isChanged,
    onUpload,
    onUpdateBackground,
    onImageChange,
    setWithoutBackgrounds,
    onDeleteImage,
    isImageLoading,
    notRequired = false,
    title = 'image',
    value,
    force
}) => {
    const { t } = useTranslation();
    const { direction } = useContext(AppContext);
    return (
        <React.Fragment key={fieldName}>
            <Col span={24}>
                <FormItem label={t(title)}>
                    <Controller
                        name={fieldName}
                        rules={{ required: !notRequired && true }}
                        render={({ field }) => (
                            <ImageUploader
                                {...field}
                                type="DRAGGER"
                                imageFor={MediumFor.UserProfile}
                                onChange={(response) => {
                                    onImageChange(response);
                                    field.onChange(response?.id);
                                }}
                            />
                        )}
                    />
                    {currentImage && (
                        <Button
                            type="text"
                            danger
                            icon={isImageLoading ? <LoadingOutlined /> : <DeleteOutlined />}
                            loading={isImageLoading}
                            onClick={onDeleteImage}
                            style={{
                                marginTop: 8,
                                float: direction === 'rtl' ? 'left' : 'right',
                            }}
                        >
                            {t("delete")}
                        </Button>
                    )}

                </FormItem>
            </Col>

            <div
                style={{
                    marginTop: 16,
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: 32,
                }}
            >
                {currentImage && (
                    <div style={{ textAlign: "center", flex: "1 1 300px" }}>
                        <h4>{t("old_image")}</h4>
                        <Image
                            src={currentImage.url}
                            preview={true}
                            style={{ width: "100%", maxHeight: 300, objectFit: "contain" }}
                            alt="Old"
                        />
                    </div>
                )}

                {newImageUrl && (
                    <div style={{ textAlign: "center", flex: "1 1 300px" }}>
                        <h4>{t("new_image")}</h4>
                        <Image
                            src={newImageUrl}
                            preview={true}
                            style={{ width: "100%", maxHeight: 300, objectFit: "contain" }}
                            alt="New"
                        />
                    </div>
                )}
            </div>

            {isChanged && (
                <Col span={24} >
                    <Button
                        type="primary"
                        onClick={onUpload}
                        style={{ marginTop: 16, marginBottom: 8, display: "block" }}
                        loading={isImageLoading}
                    >
                        {t("upload_new_image")}
                    </Button>
                </Col>
            )}

            {(currentImage || force) && <Col span={24}>
                <FormItem>
                    <Checkbox
                        checked={value ?? false}
                        onChange={(e) => {
                            setWithoutBackgrounds(e.target.checked);
                        }}
                    >
                        {t("without_background")}
                    </Checkbox>
                </FormItem>

                {!isChanged && (
                    <Button
                        type="default"
                        onClick={onUpdateBackground}
                        style={{ marginTop: 10, marginInline: 5, display: "inline" }}
                    >
                        {t("update_image_kind")}
                    </Button>
                )}
            </Col>}
        </React.Fragment>
    );
};

export default ImageFieldBlock;
